import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CommonDataService } from '../../services/common-data.service';
import { GraphqlService } from '../../services/graphql.service';

@Component({
  selector: 'app-back-button',
  templateUrl: './back-button.component.html'
  // styleUrls: ['./back-button.component.css']
})
export class BackButtonComponent implements OnInit {

  @Input() GlossaryTerm:boolean;
  @Input() WhatLinksHere:boolean;
  @Input() crossRef:boolean;
  @Input() whatLinksHereTitle;
  @Input() whatLinksHereUrl;
  @Input() Xbrl:boolean;

  backPathText: string = "";
  backPathLink: string = "";
  backTo: string = "";

  constructor(private route: Router,
    private commonDataService: CommonDataService,
    private graphQLService: GraphqlService
    ) { }

  ngOnInit(): void {
    if (this.Xbrl && localStorage.getItem("xbrlReturnPathText") != null && localStorage.getItem("xbrlReturnPathLink") != null) {
      this.backPathText = localStorage.getItem("xbrlReturnPathText").replace("-null","");
      this.backPathLink = localStorage.getItem("xbrlReturnPathLink").replace("-null", "");
    }
    // this.graphQLService.getGlobalLabels().subscribe(data => { this.getGlobalLabel(data); });
  }
  crossRefBack() {
    this.commonDataService.backbuttoncrossreference.next(true);
    localStorage.removeItem("crossreferencedParaID");
    this.route.navigateByUrl("/crossreference");
  }

  glossaryBack() {
    this.commonDataService.glossaryTermBackButtonClicked.next(true);
    this.commonDataService.glossaryTerm.next(this.commonDataService.glossaryTermFromContentPageBackButton.getValue());
    this.commonDataService.glossaryTermFromContentPageBackButton.next("");
    this.route.navigateByUrl("/MasterGlossary");
  }

  backToWhatLinksHerePage() {
    this.route.navigateByUrl(this.whatLinksHereUrl);
  }

  XbrlBack() {
    localStorage.removeItem("xbrlReturnPathLink");
    this.route.navigateByUrl(this.backPathLink);
  }
   
  // getGlobalLabel(data) {
  //   if (data != "") {
  //     var labels = data.content.data.labels;
  //     labels = labels.filter(x => x.key.trim());
  //     this.backTo = labels.filter(x => x.key == "backTo_Label").map(y => y.value);
  //   }
  // }
}
